import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  reviews: {},
  serviceProviderReviews: {},
  selectedServiceProviderReviewInfoDetails: {},
  selectedReviewId: null,
};

const reviews = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_REVIEWS_LIST: {
      draft.reviews = payload?.reviews;
      break;
    
    }
    case Actions.GET_SERVICE_PROVIDER_REVIEWS_LIST: {
      draft.serviceProviderReviews = payload?.reviews;
      break;
    }

    case Actions.SELECTED_REVIEW_ID: {
      draft.selectedReviewId = payload?.selectedReviewId;
      break;
    }

    case Actions.SELECTED_SERVICE_PROVIDER_REVIEW_INFO_DETAILS: {
      draft.selectedServiceProviderReviewInfoDetails = payload?.selectedServiceProviderReviewInfoDetails;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default reviews;
